import { BUSINESS_TYPE_CRM_VALUE } from '@constants/leadCaptureConstants';
import type { LeadCaptureFormValues } from '@components/LeadCaptureForm/LeadCaptureForm.types';

const stripUndefined = (record: Record<string, unknown>): Record<string, unknown> =>
  Object.fromEntries(Object.entries(record).filter(([, v]) => v !== undefined));

export const buildLeadSubmissionPayload = (
  values: LeadCaptureFormValues,
  contextPayload?: Record<string, unknown>
): Record<string, unknown> => {
  const street = [values.streetNumber, values.streetName].filter(Boolean).join(' ');
  const address: Record<string, unknown> = {
    street,
    ...(values.unitNumber ? { unitNumber: values.unitNumber } : {}),
    city: values.city,
    state: values.state?.value || '',
    postalCode: values.postalCode,
    country: values.country,
  };

  const submissionValues: Record<string, unknown> = {
    ...values,
    howDidYouHear: values.howDidYouHear?.value || '',
    typeOfServiceNeeded: values.typeOfServiceNeeded.join(';'),
    address,
  };

  delete submissionValues.streetNumber;
  delete submissionValues.streetName;
  delete submissionValues.unitNumber;
  delete submissionValues.city;
  delete submissionValues.state;
  delete submissionValues.postalCode;
  delete submissionValues.country;

  if (values.businessFields) {
    const industrySlug = values.businessFields.industrySector?.value || '';
    submissionValues.businessFields = {
      ...values.businessFields,
      industrySector: BUSINESS_TYPE_CRM_VALUE[industrySlug] ?? industrySlug,
      serviceOfInterest: values.businessFields.serviceOfInterest.map((o) => o.value).join(';'),
      numberOfEmployees: Number(values.businessFields.numberOfEmployees?.value) || 0,
    };
  }

  if (values.customerType === 'RESIDENTIAL') {
    delete submissionValues.businessFields;
    submissionValues.company = `${values.firstName} ${values.lastName}`.trim();
  }

  if (!contextPayload) return submissionValues;
  return { ...submissionValues, ...stripUndefined(contextPayload) };
};
